import * as settingsSagas from './settings/sagas';

export const uiSagas = [...Object.values(settingsSagas)];
